export const formatSize = (size: number) => {
  const kiloBytes = size / 1024;
  const megaBytes = kiloBytes / 1024;

  if (megaBytes >= 1) {
    return `${Math.floor(megaBytes)} MB`;
  } else {
    return `${Math.floor(kiloBytes)} KB`;
  }
};
